import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {LABEL_FLOAT, LAYOUT_TYPE_FULL, MINO_STYLE, NAV_STYLE_FIXED, THEME_TYPE_SEMI_DARK} from "constants/ThemeSetting";

interface themeModel {
    navStyle: string,
    layoutType: string,
    themeType: string,
    themeColor: string,
    isDirectionRTL: boolean
    navCollapsed: boolean,
    width: number,
    labelType:string,
    menuFold: boolean,
    fullScreen:boolean,
}

const initialState:themeModel = {
    navStyle: NAV_STYLE_FIXED,
    layoutType: LAYOUT_TYPE_FULL,
    themeType: THEME_TYPE_SEMI_DARK,
    themeColor:MINO_STYLE,
    isDirectionRTL: false,
    navCollapsed: true,
    width: window.innerWidth,
    // labelType: LABEL_NORMAL
    labelType: LABEL_FLOAT,
    menuFold: false,
    fullScreen:false,
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setDirectionRTL: (state, action: PayloadAction<any>) => {
            state.isDirectionRTL = action.payload;
        },
        toggleCollapsedSideNav: (state, action:PayloadAction<boolean>) => {
            state.navCollapsed = action.payload;
        },
        updateWindowWidth: (state, action:PayloadAction<number>) => {
            state.width = action.payload;
        },
        setMenuFold: (state, action:PayloadAction<boolean>) => {
            state.menuFold = action.payload;
        },
        setFullScreen: (state, action:PayloadAction<boolean>) => {
            state.fullScreen = action.payload;
        },
    }
})

export const { setDirectionRTL, toggleCollapsedSideNav, updateWindowWidth, setMenuFold, setFullScreen } = themeSlice.actions;

export default themeSlice.reducer;
